import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import { DateTimePicker } from '@material-ui/pickers'
import IconButton from '@material-ui/core/IconButton'
import ClearIcon from '@material-ui/icons/Clear'
import makeStyles from '@material-ui/core/styles/makeStyles'
import { useValidationSchema } from 'context/validationSchema'
import { useField } from 'formik'
import { isFieldRequired } from 'components/Shared/FormikForm'
import { CustomWarningMessageText } from 'components/Shared/ErrorMessage'
import { momentToISOLocalDateTime } from 'utils/date'

const useStyles = makeStyles({
  dateTimePicker: {
    marginBottom: '27px',
    width: '100%',
    '& div': {
      height: '58px',
      '& input': {
        padding: '27px 12px 10px',
        height: '24px'
      }
    },
  }
})

export function DateTimePickerField ({ placeholder, fieldName, label, disabled, className = '', disableClear }) {
  const { schema } = useValidationSchema()

  const [{ value }, { error, touched }, { setValue, setTouched }] = useField(fieldName)
  const { t } = useTranslation()
  const classes = useStyles()

  const isRequired = useMemo(() => isFieldRequired(schema, fieldName), [schema, fieldName])

  function handleChange (momentValue) {
    const newValue = momentToISOLocalDateTime(momentValue)
    setTouched(true)
    setValue(newValue)
  }

  const isError = !!error && touched

  return (
    <>
      <DateTimePicker
        error={isError}
        value={value}
        disableToolbar
        label={label}
        variant="inline"
        inputVariant="filled"
        placeholder={t(placeholder)}
        onChange={handleChange}
        format={'DD-MM-YYYY HH:mm'}
        autoOk
        ampm={false}
        className={`${className} ${classes.dateTimePicker}`}
        required={isRequired}
        disabled={disabled}
        onBlur={() => setTouched(true)}
        InputProps={{
          disableUnderline: true,
          endAdornment: (
            (value && !disableClear && !disabled) &&
            <IconButton size="small"
                        onClick={(event) => {
                          setTouched(true)
                          setValue(null)
                          event.stopPropagation()
                        }}>
              <ClearIcon fontSize="inherit"/>
            </IconButton>
          )
        }}
      />
      {isError && <CustomWarningMessageText message={t(error)}/>}
    </>
  )
}
